import { IVisibilityAcl } from "@/shared/api/groups"
import { AclStrategy } from "@/shared/api/groups"
import { getAclStrategyLabel } from "../config"

interface VisibilityAclListProps {
    aclList: IVisibilityAcl[]
    isLoading: boolean
    isDeleting: string | null
    onDelete: (aclId: string) => void
    getStrategyLabel?: (strategy: AclStrategy) => string
}

export const VisibilityAclList = ({
    aclList,
    isLoading,
    isDeleting,
    onDelete,
    getStrategyLabel = getAclStrategyLabel,
}: VisibilityAclListProps) => (
    <div className="flex flex-col gap-3">
        <h3 className="text-lg font-semibold">Список ACL для объекта</h3>
        {isLoading ? (
            <div className="text-center py-4">Загрузка...</div>
        ) : aclList.length === 0 ? (
            <div className="text-center py-4 text-gray-500">Нет ACL записей</div>
        ) : (
            <div className="flex flex-col gap-2">
                {aclList.map((acl) => (
                    <div key={acl.id} className="border rounded-lg p-3 flex justify-between items-start">
                        <div className="flex flex-col gap-1">
                            <div className="text-sm text-gray-600">
                                Стратегия: {getStrategyLabel(acl.acl_strategy)}
                            </div>
                            {acl.groups === null ? (
                                <div className="text-sm text-gray-600">Видимые группы: Все группы</div>
                            ) : acl.groups && acl.groups.length > 0 ? (
                                <div className="text-sm text-gray-600">
                                    Видимые группы: {acl.groups.map((group) => group.name).join(', ')}
                                </div>
                            ) : (
                                <div className="text-sm text-gray-600">Видимые группы: Не указаны</div>
                            )}
                        </div>
                        <button
                            onClick={() => onDelete(acl.id)}
                            disabled={isDeleting === acl.id}
                            className="text-red-600 hover:text-red-800 disabled:opacity-50 px-2 py-1"
                            type="button"
                        >
                            {isDeleting === acl.id ? 'Удаление...' : 'Удалить'}
                        </button>
                    </div>
                ))}
            </div>
        )}
    </div>
)
